/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/product-card.js":
/*!***************************************!*\
  !*** ./js/components/product-card.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  var variantDrawerTrigger = document.querySelectorAll('[data-drawer-trigger]');
  variantDrawerTrigger.forEach(trigger => {
    var productHandle = trigger.dataset.productHandle;
    if (!productHandle) return;
    trigger.addEventListener('click', () => {
      console.log("clicked choose option button");
      if (window.updateVariantData) {
        window.updateVariantData(productHandle);
      }
    });
  });
});

/***/ }),

/***/ "./js/sections/b2b-login.js":
/*!**********************************!*\
  !*** ./js/sections/b2b-login.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  document.querySelectorAll('[data-register-dropdown]').forEach(button => {
    var dropdownData = button.nextElementSibling;
    if (!dropdownData) return;
    button.addEventListener("mouseenter", () => {
      dropdownData.classList.remove("tw-hidden");
    });
    button.addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (!dropdownData.matches(":hover")) {
          dropdownData.classList.add("tw-hidden");
        }
      }, 100);
    });
    dropdownData.addEventListener("mouseleave", () => {
      dropdownData.classList.add("tw-hidden");
    });
    dropdownData.addEventListener("mouseenter", () => {
      dropdownData.classList.remove("tw-hidden");
    });
  });
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!*********************************!*\
  !*** ./js/sections/sections.js ***!
  \*********************************/
/* harmony import */ var JsComponents_product_card__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/product-card */ "./js/components/product-card.js");
/* harmony import */ var _b2b_login__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./b2b-login */ "./js/sections/b2b-login.js");


document.addEventListener('DOMContentLoaded', () => {
  (0,JsComponents_product_card__WEBPACK_IMPORTED_MODULE_0__["default"])();
  (0,_b2b_login__WEBPACK_IMPORTED_MODULE_1__["default"])();
});
})();

/******/ })()
;